import { concat as _concat } from 'lodash';
import { NewConfigurationFormModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../../app/Pages/Dashboard/Configuration/ConfigurationNew/ConfigurationNew.messages';

export const newConfigurationFormData = (): NewConfigurationFormModel => ({
  name: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.configurationNewFormNameError}),
    label: formatMessage({...MESSAGES.configurationNewFormNameLabel}),
    name: 'name',
    type: 'text',
    placeholder: formatMessage({...MESSAGES.configurationNewFormNamePlaceholder}),
    required: true,
    validation: 'isLength',
    value: '',
  },
  pricingsAccessories: {
    col: 6,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.configurationNewFormPricingsAccessoriesError}),
    label: formatMessage({...MESSAGES.configurationNewFormPricingsAccessoriesLabel}),
    name: 'pricingsAccessoriesId',
    type: 'select',
    placeholder: formatMessage({...MESSAGES.configurationNewFormPricingsAccessoriesLabel}),
    required: true,
    validation: 'isLength',
    value: '',
    multiple: false,
    options: _concat(
      [], 
      [{
        label: formatMessage({...MESSAGES.configurationNewFormPricingsAccessoriesPlaceholder}),
        value: '',
        disabled: true,
      }]
    )
  },
  pricingsWashbasin: {
    col: 6,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.configurationNewFormPricingsWashbasinError}),
    label: formatMessage({...MESSAGES.configurationNewFormPricingsWashbasinLabel}),
    name: 'pricingsWashbasinId',
    type: 'select',
    placeholder: formatMessage({...MESSAGES.configurationNewFormPricingsWashbasinLabel}),
    required: true,
    validation: 'isLength',
    value: '',
    multiple: false,
    options: _concat(
      [], 
      [{
        label: formatMessage({...MESSAGES.configurationNewFormPricingsWashbasinPlaceholder}),
        value: '',
        disabled: true,
      }]
    )
  },
});
